/**
 * Keyword-based category matching
 * Checks transaction descriptions against user-defined keywords
 */

/**
 * Load keyword mappings from localStorage
 * @returns {Object} Keyword to category mappings
 */
export function loadKeywordMappings() {
  const stored = localStorage.getItem('categoryKeywords');
  return stored ? JSON.parse(stored) : {};
}

/**
 * Check if transaction description matches any keywords
 * @param {string} description - Transaction description
 * @returns {string|null} Matched category or null
 */
export function matchKeywordCategory(description) {
  if (!description) {
    return null;
  }

  const keywords = loadKeywordMappings();
  const lowerDescription = description.toLowerCase();

  // Check each keyword
  for (const [keyword, category] of Object.entries(keywords)) {
    if (lowerDescription.includes(keyword.toLowerCase())) {
      return category;
    }
  }

  return null;
}
